FiltersMdl.controller('EffectFans', [ '$scope', '$state', 'effect_fans', 'effect_fan', 'HuesSrv', function ( $scope, $state, effect_fans, effect_fan, HuesSrv ) {

	this.effect_fans = effect_fans;

	HuesSrv.setFilter('search_term', false );
	HuesSrv.setFilter('search_single', false );
	HuesSrv.setFilter('effect_fan', effect_fan ? effect_fan : effect_fans );





	//If the sate has an active child state, the child state handles the hue request (see ColorFansCtrl)
	if ( $state.current.name !== 'main.categories.families.effects' )
		return;


	HuesSrv.setFilter('color_fan', false );




}]);
